export const post = (state) => state.post;
